module.exports = __webpack_public_path__ + "static/media/uncheck_with_bg.27fecd5b.svg";